var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Resource Type")]),
            _vm._v(" "),
            _c("multiselect", {
              attrs: {
                name: "link_type",
                options: _vm.optionsForLinkType.map(function(x) {
                  return x.id
                }),
                label: "name",
                "allow-empty": false
              },
              scopedSlots: _vm._u([
                {
                  key: "singleLabel",
                  fn: function(props) {
                    return [
                      _c("img", {
                        staticClass: "link-type-icon",
                        attrs: {
                          src: require("@/csmworkflow/img/" +
                            _vm.getOptionObject(props.option).icon),
                          alt: "icon"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "link-type-title" }, [
                        _vm._v(_vm._s(_vm.getOptionObject(props.option).name))
                      ])
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(props) {
                    return [
                      _c("img", {
                        staticClass: "link-type-icon",
                        attrs: {
                          src: require("@/csmworkflow/img/" +
                            _vm.getOptionObject(props.option).icon),
                          alt: "icon"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "link-type-title" }, [
                        _vm._v(_vm._s(_vm.getOptionObject(props.option).name))
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.type.value,
                callback: function($$v) {
                  _vm.$set(_vm.type, "value", $$v)
                },
                expression: "type.value"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isFile,
              expression: "!isFile"
            }
          ],
          staticClass: "col-md-12"
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("URL")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.url.value,
                    expression: "url.value"
                  }
                ],
                ref: "focusThis",
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.url.value },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.saveFn.apply(null, arguments)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.url, "value", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group-append" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-text btn-copy",
                      attrs: {
                        id: "copy-url-btn",
                        type: "button",
                        "data-dismiss": "modal"
                      },
                      on: { click: _vm.copyUrl }
                    },
                    [_c("i", { class: _vm.copyIcon })]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target: "copy-url-btn",
                        triggers: "hover",
                        noninteractive: ""
                      }
                    },
                    [_vm._v(_vm._s(_vm.copyTooltipText))]
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error,
              expression: "error"
            }
          ],
          staticClass: "col-md-12"
        },
        [
          _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v("URL is invalid")
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Label")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.label.value,
                expression: "label.value"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", disabled: _vm.isFile },
            domProps: { value: _vm.label.value },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveFn.apply(null, arguments)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.label, "value", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Notes")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.notes.value,
                expression: "notes.value"
              }
            ],
            staticClass: "form-control",
            domProps: { value: _vm.notes.value },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.notes, "value", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row col-md-12" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", "data-dismiss": "modal" },
              on: { click: _vm.saveFn }
            },
            [_vm._v("Save")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-text",
              attrs: { type: "button", "data-dismiss": "modal" },
              on: { click: _vm.removeLink }
            },
            [_vm._v("Delete")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.removeFn },
          model: {
            value: _vm.showRemoveLink,
            callback: function($$v) {
              _vm.showRemoveLink = $$v
            },
            expression: "showRemoveLink"
          }
        },
        [
          _c("p", [
            _vm._v("Are you sure you want to delete this resource/link?")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }